/* Size guide popup for the product "Size guide" block. */
(function () {
  if (customElements.get('size-guide')) return;

  class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-size-guide-modal]');
      this.opener = this.querySelector('[data-size-guide-open]');
      if (!this.modal || !this.opener) return;

      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
      };
      this.opener.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-size-guide-close]').forEach((element) => {
        element.addEventListener('click', () => this.close());
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.classList.remove('size-guide-open');
    }

    open() {
      this.modal.hidden = false;
      document.body.classList.add('size-guide-open');
      document.addEventListener('keydown', this.onKeydown);
      const close = this.modal.querySelector('.size-guide__close');
      if (close) close.focus();
    }

    close() {
      this.modal.hidden = true;
      document.body.classList.remove('size-guide-open');
      document.removeEventListener('keydown', this.onKeydown);
      this.opener.focus();
    }
  }

  customElements.define('size-guide', SizeGuide);
})();
